import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { TemplateTaskConstants } from "../../../../constants";
import { DeadlineOperator, DefaultDeadline, SelectData, TemplateTaskPanelData } from "../../../../models";
import { sentenceOrPascalToCamel } from "../../../../utils";

interface TemplateTaskPanelRightProps {
  currentTemplateTask: TemplateTaskPanelData;
  currentStepPhase: string | undefined;
  setDefaultDeadline: Dispatch<SetStateAction<DefaultDeadline>>;
}

interface TemplateTaskPanelRightReturnData {
  availableOperator: SelectData;
}

export const useTemplateTaskPanelRight = ({
  currentTemplateTask,
  currentStepPhase,
  setDefaultDeadline,
}: TemplateTaskPanelRightProps): TemplateTaskPanelRightReturnData => {
  const [availableOperator, setAvailableOperator] = useState(TemplateTaskConstants.DEADLINE_OPERATOR_SELECT_DATA);

  useEffect(() => {
    // DEADLINE_OPERATOR_MAP is keyed on camelCase. defaultDeadlineField is stored camelCase, but a
    // step's phase can still come back title-cased from older rows, so normalise before the lookup.
    const phaseKey = currentStepPhase ? sentenceOrPascalToCamel(currentStepPhase) : undefined;
    const compositeKey = `${currentTemplateTask?.defaultDeadlineField}|${phaseKey}`;
    const key =
      currentTemplateTask?.defaultDeadlineField && phaseKey && TemplateTaskConstants.DEADLINE_OPERATOR_MAP[compositeKey]
        ? compositeKey
        : (currentTemplateTask?.defaultDeadlineField ?? "");

    const operator = TemplateTaskConstants.DEADLINE_OPERATOR_MAP[key];

    if (operator) {
      setAvailableOperator(TemplateTaskConstants.DEADLINE_OPERATOR_SELECT_DATA.filter((op) => op.value === operator));
      setDefaultDeadline((prev) => ({
        ...prev,
        operator: operator as DeadlineOperator,
      }));
    } else {
      setAvailableOperator(TemplateTaskConstants.DEADLINE_OPERATOR_SELECT_DATA);
      setDefaultDeadline((prev) => ({
        ...prev,
        operator: prev.operator ?? TemplateTaskConstants.DEADLINE_OPERATOR_SELECT_DATA[0].value,
      }));
    }
  }, [currentTemplateTask?.defaultDeadlineField, currentStepPhase, currentTemplateTask]);

  return { availableOperator };
};
